export default "__VITE_ASSET__DuMHErVl__"